<script lang="ts">
  import { twMerge } from 'tailwind-merge';

  let clazz = '';
  export { clazz as class };
</script>

<div
  class="u-button-panel {twMerge(
    'flex flex-wrap w-fit rounded border border-gray-400 shadow-md shadow-gray-300 text-center overflow-hidden',
    clazz
  )}"
>
  <slot />
</div>

<style lang="postcss">
  .u-button-panel:global {
    /* Suppress white space from spaces in html w/ flex */

    .u-button {
      @apply rounded-none mx-0 border-gray-400 border-r border-b flex-grow;
      overflow: hidden;
      margin-left: 0;
      margin-right: 0;
      margin-top: 0;
      margin-bottom: 0;
    }

    .u-button:not(.checked) {
      @apply shadow-none;
    }

    button:nth-child(1),
    /* 
     * Labels are preceeded by their accessible input element, so they
     * will always be the 2nd child.
     */
    label:nth-child(2) {
      /* @apply rounded-tl; */
    }
    button:last-child,
    label:last-child {
      /* @apply rounded-br; */
    }
  }
</style>
